import { Button, Modal, Form, Row, Col, Input, Select } from "antd";
import { PasswordInput } from "antd-password-input-strength";
import { message } from "antd";
import zxcvbn from "zxcvbn";
import { useEffect, useState } from "react";
import fetchAllSites from "../../../../services/fetchAllSites";
import fetchAllRoles from "../../../../services/fetchAllRoles";
import createUser from "../../../../services/createUser";
import { accessLevels } from "../../../../utils/data";
import fetchDataTrace from "../../../../services/fetchDataTrace";

const { Option } = Select;

export default function CreateUser({
  isVisible,
  isLoading,
  setVisible,
  refetch,
}: any) {
  const [form] = Form.useForm();
  const [roles, setRoles] = useState<any>([]);
  const [sites, setSites] = useState<any>([]);
  const [firms, setFirms] = useState<any>([]);

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const { password } = form.getFieldsValue();
    const score = password.length === 0 ? -1 : zxcvbn(password).score;
    if (score < 3) {
      message.error("Use stronger password");
    } else {
      const response = await createUser(values);
      if (response.success) {
        message.success("Registed Successfully");
        refetch();
        setVisible(false);
      } else {
        message.error(response.message);
      }
    }
  };

  const handleFetchRoles = async () => {
    const response = await fetchAllRoles();
    setRoles(response?.payload);
  };

  const handleFetchFirms = async () => {
    const uri = `firms`;
    const response = await fetchDataTrace({ uri });
    setFirms(response?.payload);
  };

  const handleFetchSites = async () => {
    const response = await fetchAllSites();
    setSites(response?.payload);
  };

  const siteOptions = sites.map((site: any, index: number) => (
    <Option value={site?._id} key={index}>
      {site?.name}
    </Option>
  ));

  const roleOptions = roles.map((role: any, index: number) => (
    <Option value={role?._id} key={index}>
      {role?.name}
    </Option>
  ));

  const accessOptions = accessLevels?.map((level: any, index: number) => (
    <Option value={level?.id} key={index}>
      Access Level {level?.id}
    </Option>
  ));

  const firmOptions = firms?.map((company: any, index: number) => (
    <Option value={company?._id} key={index}>
      {company?.name}
    </Option>
  ));

  useEffect(() => {
    handleFetchSites();
    handleFetchRoles();
    handleFetchFirms();
    form.setFieldsValue({
      password: "karimjee200TZTZ",
      accessLevel: "2",
      isClaimer: true,
      mobile: "+255718194594",
      mobile2: "+255718194594",
      role: "63731af8183c4f2a3cb95489",
      site: "6224dcf60c5c49d9fec9218f"

    });
  }, []);

  return (
    <Modal
      visible={isVisible}
      title="New User"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="AddUser"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="AddUser"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="firstname"
              label={"Firstname"}
              rules={[
                {
                  required: true,
                  message: "Please enter Firstname",
                },
              ]}
            >
              <Input placeholder="First Name" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="lastname"
              label={"Lastname"}
              rules={[
                {
                  required: true,
                  message: "Please enter Lastname",
                },
              ]}
            >
              <Input placeholder="Last Name" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="email"
              label={"Email"}
              rules={[
                {
                  required: true,
                  message: "Please enter Email",
                },
              ]}
            >
              <Input
                type={"email"}
                placeholder="Email"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="kjlID"
              label={"KJL ID"}
              rules={[
                {
                  required: true,
                  message: "Please enter KJL ID",
                },
              ]}
            >
              <Input
                type={"text"}
                placeholder="KJL ID"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="firm"
              label={"Firm"}
              rules={[
                {
                  required: false,
                  message: "Please select company",
                },
              ]}
            >
              <Select placeholder="Company">{firmOptions}</Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="password"
              label={"Password"}
              rules={[
                {
                  required: true,
                  message: `Please enter Password`,
                },
              ]}
            >
              <PasswordInput
                inputProps={{
                  size: "middle",
                  placeholder: "Password",
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mobile"
              label={"Mobile 1"}
              rules={[
                {
                  required: true,
                  message: "Please enter Mobile 1",
                },
              ]}
            >
              <Input placeholder="Mobile 1" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mobile2"
              label={"Mobile 2 (Optional)"}
              rules={[
                {
                  required: false,
                  message: "Please enter Mobile 2",
                },
              ]}
            >
              <Input placeholder="Mobile 2" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>

          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="site"
              label={"Site"}
              rules={[
                {
                  required: true,
                  message: "Please select office",
                },
              ]}
            >
              <Select placeholder="Office">{siteOptions}</Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="role"
              label={"Role"}
              rules={[
                {
                  required: true,
                  message: "Please select role",
                },
              ]}
            >
              <Select placeholder="Role">{roleOptions}</Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="accessLevel"
              label={"Access Level"}
              rules={[
                {
                  required: true,
                  message: "Please select access level",
                },
              ]}
            >
              <Select placeholder="Access Level">{accessOptions}</Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 6 }}>
            <Form.Item
              name="isClaimer"
              label={"Claim Privilege"}
              rules={[
                {
                  required: false,
                  message: "Please select claim status",
                },
              ]}
            >
              <Select defaultValue={false} placeholder="Claim">
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 6 }}>
            <Form.Item
              name="isMessaged"
              label={"Booking SMS"}
              rules={[
                {
                  required: false,
                  message: "Please select sms status",
                },
              ]}
            >
              <Select defaultValue={false} placeholder="SMS">
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="isRoadside"
              label={"Roadside Access"}
              rules={[
                {
                  required: false,
                  message: "Please select one option",
                },
              ]}
            >
              <Select defaultValue={false} placeholder="Roadside">
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
